import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { NumberToCurrencyPipe } from '../../../../shared/pipes/number-to-currency.pipe';
import { TranslatePipe } from '../../../../shared/pipes/trans.pipe';
import { ICard } from '../../core/interfaces/ICard';
import { CardsService } from '../../core/services/CardsService';
import { Observable } from 'rxjs';
import { BasePagedTableComponent } from '../../../../core/layout/components/abstracts/base-paged-table.component';
import { IResponse } from '../../../../core/interfaces/IResponse';
import { IPagedResults } from '../../../../core/interfaces/IPagedResults';
import { ICardTransaction } from '../../core/interfaces/ICardTransaction';
import { LocaleDatetimeFormatPipe } from '../../../../shared/pipes/locale-datetime-format.pipe';
import { MathAbsPipe } from '../../../../shared/pipes/math-abs.pipe';
import { PagedTableComponent } from '../../../../shared/components/paged-table/paged-table.component';

@Component({
  selector: 'app-card-transactions-table',
  standalone: true,
  imports: [
    NumberToCurrencyPipe,
    TranslatePipe,
    LocaleDatetimeFormatPipe,
    MathAbsPipe,
    PagedTableComponent
  ],
  templateUrl: './card-transactions-table.component.html',
  styleUrl: './card-transactions-table.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CardTransactionsTableComponent extends BasePagedTableComponent<ICardTransaction> {

  @Input({ required: true }) card: ICard;

  private readonly _cardsService = inject(CardsService);

  protected override get data$(): Observable<IResponse<IPagedResults<ICardTransaction>>> {
    return this._cardsService.getCardTransactions(this.card.cardId, this.pagination);
  }
}
